var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rc-wrapper rc-dashboard-layout"},[_c('rc-skip-nav'),_c('RcAuthStatusBanner'),_c('RcSiteHeader'),_c('div',{staticClass:"main-container"},[_c('rc-site-content')],1),_c('rc-notifications')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }